export default __webpack_public_path__ + "static/2.5.2/media/loginimage.0fede9a4.svg";